import { Link } from 'react-router-dom';
import { portfolioCategories } from '../config/portfolio';

function PicPortfolio({ categories = portfolioCategories }) {
  if (categories.length === 0) {
    return (
      <div className="py-16 text-center text-sm text-neutral-500">
        Добавьте папку с фото в <code className="text-neutral-700">public/assets/portfolio/</code> и
        запустите <code className="text-neutral-700">npm run generate:portfolio</code>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 md:grid md:grid-cols-4 md:gap-5">
      {categories.map((category) => (
        <Link
          key={category.slug}
          to={`/portfolio/${category.slug}`}
          className="group relative aspect-[3/4] w-full overflow-hidden rounded-2xl bg-neutral-100 md:aspect-[3/4]"
        >
          <img
            src={category.cover}
            alt={category.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black/45 opacity-100 transition-opacity duration-300 md:bg-black/40 md:opacity-0 md:group-hover:opacity-100">
            <span className="px-4 text-center font-sans text-xs uppercase tracking-[0.14em] text-white md:text-sm">
              {category.title}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default PicPortfolio;
